import React from 'react';
import StaticPageLayout from '../components/Layout/StaticPageLayout';

const ShippingInfo = () => {
  return (
    <StaticPageLayout title="Shipping Info" draftNotice>
      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Delivery Estimates</h2>
        <p>
          Express delivery usually arrives the next day, and normal delivery within about 4 days,
          depending on your location. Each product page shows an estimated delivery date at checkout time.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Delivery Charges</h2>
        <p>[TODO: confirm delivery charges and any free-shipping order threshold].</p>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Order Tracking</h2>
        <p>
          Once your order is placed, you can view its status (Confirmed, Packing, Shipped, Out for Delivery,
          Delivered) from the Orders section of your account.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Delivery Areas</h2>
        <p>[TODO: confirm which regions/pin codes we currently deliver to].</p>
      </div>
    </StaticPageLayout>
  );
};

export default ShippingInfo;
